import { Link } from 'react-router-dom';
import type { MangaArticle } from '@/pages/article/types';

interface ArticleCardProps {
  article: MangaArticle;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.id}`}
      className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-primary-200 hover:-translate-y-1 cursor-pointer"
      onClick={() => window.scrollTo({ top: 0, behavior: 'instant' as const })}
    >
      <div className="aspect-[3/4] overflow-hidden relative">
        <img
          src={article.coverImage}
          alt={article.title}
          title={`${article.title} - bl漫画推荐`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-3 left-3">
          <span className="inline-block px-2.5 py-1 rounded-full text-xs font-medium bg-primary-500 text-background-50 whitespace-nowrap">
            {article.category}
          </span>
        </div>
        <div className="absolute top-3 right-3 flex items-center gap-1 bg-background-50/90 backdrop-blur-sm rounded-full px-2.5 py-1">
          <i className="ri-star-fill text-xs text-accent-500"></i>
          <span className="text-xs font-bold text-foreground-800">{article.rating}</span>
        </div>
        {article.status === '连载中' && (
          <div className="absolute bottom-3 right-3">
            <span className="inline-block px-2 py-0.5 rounded-full text-xs font-medium bg-accent-500 text-background-50 whitespace-nowrap">
              {article.status}
            </span>
          </div>
        )}
      </div>
      <div className="p-4">
        <h3 className="font-heading text-base text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
          {article.title}
        </h3>
        <p className="mt-2 text-xs text-foreground-500 line-clamp-2 leading-relaxed">
          {article.description}
        </p>
        <div className="mt-3 flex items-center justify-between">
          <span className="text-xs text-foreground-400">{article.author}</span>
          <span className="text-xs text-foreground-400">{article.viewCount.toLocaleString()} 阅读</span>
        </div>
      </div>
    </Link>
  );
}